import { useMemo } from 'react';
import { useTheme } from 'styled-components';

import { Message, MessageType, StatusIconType } from '@dreryk/react-components';

import { visitHistoryTranslationKeys } from '../translations';

const t = visitHistoryTranslationKeys;

export const VisitHistoryAttachmentStatus = (): JSX.Element => {
   const theme = useTheme();
   const options = useMemo(
      () => ({ [StatusIconType.NEGATIVE]: { color: theme.error, backgroundColor: theme.errorLighter } }),
      [theme]
   );

   return (
      <Message
         testId={'visitHistoryAttachmentStatus'}
         type={MessageType.NEGATIVE}
         displayIndicator
         options={options}
         label={t.removed}
      />
   );
};
